import React, { useState } from "react";
import TermsAgreement from "./screens/TermsAgreement";
import MovieDetail from 'pages/MovieBox/AddMovie/screens/MovieDetails'
import CastCrew from 'pages/MovieBox/AddMovie/screens/CastCrew'
import MovieArtwork from 'pages/MovieBox/AddMovie/screens/MovieArtwork'
import MovieUpload from 'pages/MovieBox/AddMovie/screens/MovieUpload'
import AddTrailer from 'pages/MovieBox/AddMovie/screens/AddTrailer'
import ReviewConfirm from 'pages/MovieBox/AddMovie/screens/Review'
import { useParams, useSearchParams } from "react-router-dom";
import useSWR from "swr";
import { fetcher } from "App";
import Spinner from "components/Spinner";
import Season from "./screens/Season";
import AddEpisode from "./screens/AddEpisode";

export default function AddMoviePage() {
  const [,setHasAgreed] = useState(false);
  const { step } = useParams()
  const [searchParams] = useSearchParams();

  const { data: mediaData, isValidating } = useSWR(searchParams.get('id') ? () => `/entertainment/movie-box/medias/${searchParams.get('id')}` : null, fetcher, { revalidateOnReconnect: false, revalidateOnFocus: false });
  if (isValidating) return <Spinner />
  const movieBoxRoutes = [
    { path: `movie-details`, element: <MovieDetail details={mediaData?.data} /> },
    { path: `cast-crew`, element: <CastCrew details={mediaData?.data} /> },
    { path: `movie-artwork`, element: <MovieArtwork details={mediaData?.data} /> },
    { path: `movie-upload`, element: <MovieUpload details={mediaData?.data} /> },
    { path: `episode`, element: <Season details={mediaData?.data} /> },
    { path: `add-episode`, element: <AddEpisode defaultMode="edit" details={mediaData?.data} /> },
    { path: `add-trailer`, element: <AddTrailer details={mediaData?.data} /> },
    { path: `review`, element: <ReviewConfirm details={mediaData?.data} /> },
  ];

  return movieBoxRoutes.find(movieBoxRoute => movieBoxRoute.path === step)?.element ||  <TermsAgreement
        onAgree={() => setHasAgreed(true)}
        onCancel={() => console.log("Cancel clicked")}
      />
}
